module.exports = __webpack_public_path__ + "img/feet.b833a449.svg";